import types from './types'

export const runPricingCalculation = (formData, order = null) => ({
  type: types.PRICING_CALCULATOR_RUN_ATTEMPT,
  formData,
  order,
})

export const runPricingCalculationSuccess = (result) => ({
  type: types.PRICING_CALCULATOR_RUN_SUCCESS,
  result,
})

export const runPricingCalculationFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_RUN_FAILURE,
  message,
  code,
})

export const clearPricingCalculationResult = () => ({
  type: types.PRICING_CALCULATOR_RUN_CLEAR,
})

export const resetPricingCalculationResult = () => ({
  type: types.PRICING_CALCULATOR_RESULT_RESET,
})

export const setLastPricingCalculatorExecution = (calculator, version, request) => ({
  type: types.PRICING_CALCULATOR_LAST_EXECUTION_SET,
  calculator,
  version,
  request,
})

export const sendPricingCalculatorToSupport = () => ({
  type: types.PRICING_CALCULATOR_SEND_TO_SUPPORT_ATTEMPT,
})

export const sendPricingCalculatorToSupportSuccess = (debugKey) => ({
  type: types.PRICING_CALCULATOR_SEND_TO_SUPPORT_SUCCESS,
  debugKey,
})

export const sendPricingCalculatorToSupportFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_SEND_TO_SUPPORT_FAILURE,
  message,
  code,
})

export const setPartPricing = (partId, pricing) => ({
  type: types.PRICING_CALCULATOR_PART_PRICING_SET,
  partId,
  pricing,
})

export const setFieldMappings = (calculatorKey, mappings) => ({
  type: types.PRICING_CALCULATOR_FIELD_MAPPINGS_SET,
  calculatorKey,
  mappings,
})

export const fetchCalculatorSuccess = (calculatorInstance) => ({
  type: types.PRICING_CALCULATOR_FETCH_SUCCESS,
  calculatorInstance,
})

export const fetchCalculatorFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_FETCH_FAILURE,
  message,
  code,
})

export const fetchCalculatorForm = (calculatorName, calculatorVersion) => ({
  type: types.PRICING_CALCULATOR_FORM_FETCH_ATTEMPT,
  calculatorName,
  calculatorVersion,
})

export const fetchCalculatorFormSuccess = (formDefinition) => ({
  type: types.PRICING_CALCULATOR_FORM_FETCH_SUCCESS,
  formDefinition,
})

export const fetchCalculatorFormFailure = (message) => ({
  type: types.PRICING_CALCULATOR_FORM_FETCH_FAILURE,
  message,
})

export const fetchResourcesForm = () => ({
  type: types.PRICING_CALCULATOR_RESOURCES_FORM_FETCH_ATTEMPT,
})

export const fetchResourcesFormSuccess = (resourceTypes) => ({
  type: types.PRICING_CALCULATOR_RESOURCES_FORM_FETCH_SUCCESS,
  resourceTypes,
})

export const fetchResourcesFormFailure = (message) => ({
  type: types.PRICING_CALCULATOR_RESOURCES_FORM_FETCH_FAILURE,
  message,
})

export const loadResourcesSuccess = (resources) => ({
  type: types.PRICING_CALCULATOR_RESOURCES_LOAD_SUCCESS,
  resources,
})

export const loadResourcesFailure = (message) => ({
  type: types.PRICING_CALCULATOR_RESOURCES_LOAD_FAILURE,
  message,
})

export const setResourcesDormant = (resourceType, dormant) => ({
  type: types.PRICING_CALCULATOR_RESOURCES_DORMANT_SET_ATTEMPT,
  resourceType,
  dormant,
})

export const toggleIncludeDormantResources = (resourceType, includeDormant) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_INCLUDE_DORMANT_TOGGLE,
  resourceType,
  includeDormant,
})

export const selectResourceType = (resourceType) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_TYPE_SELECT,
  resourceType,
})

export const addResource = (resource) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_ADD_ATTEMPT,
  resource,
})

export const addResourceSuccess = (resource) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_ADD_SUCCESS,
  resource,
})

export const addResourceFailure = (message) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_ADD_FAILURE,
  message,
})

export const updateResource = (resource) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_UPDATE_ATTEMPT,
  resource,
})

export const updateResourceSuccess = (resource) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_UPDATE_SUCCESS,
  resource,
})

export const updateResourceFailure = (message) => ({
  type: types.PRICING_CALCULATOR_RESOURCE_UPDATE_FAILURE,
  message,
})

export const loadAllPricingCalculators = () => ({
  type: types.PRICING_CALCULATORS_LOAD_ATTEMPT,
})

export const loadAllPricingCalculatorsSuccess = (data) => ({
  type: types.PRICING_CALCULATORS_LOAD_SUCCESS,
  data,
})

export const loadAllPricingCalculatorsFailure = (message, code) => ({
  type: types.PRICING_CALCULATORS_LOAD_FAILURE,
  message,
  code,
})

export const loadPricingCalculatorForm = (calculatorName, calculatorVersion) => ({
  type: types.PRICING_CALCULATOR_FORM_LOAD_ATTEMPT,
  calculatorName,
  calculatorVersion,
})

export const loadPricingCalculatorFormSuccess = (data) => ({
  type: types.PRICING_CALCULATOR_FORM_LOAD_SUCCESS,
  data,
})

export const loadPricingCalculatorFormFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_FORM_LOAD_FAILURE,
  message,
  code,
})

export const loadPricingCalculatorMaster = (calculatorName, calculatorVersion) => ({
  type: types.PRICING_CALCULATOR_MASTER_LOAD_ATTEMPT,
  calculatorName,
  calculatorVersion,
})

export const loadPricingCalculatorMasterSuccess = (data) => ({
  type: types.PRICING_CALCULATOR_MASTER_LOAD_SUCCESS,
  data,
})

export const loadPricingCalculatorMasterFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_MASTER_LOAD_FAILURE,
  message,
  code,
})

export const updatePricingCalculatorMaster = (data) => ({
  type: types.PRICING_CALCULATOR_MASTER_UPDATE_ATTEMPT,
  data,
})

export const updatePricingCalculatorMasterSuccess = (data) => ({
  type: types.PRICING_CALCULATOR_MASTER_UPDATE_SUCCESS,
  data,
})

export const updatePricingCalculatorMasterFailure = (message, code) => ({
  type: types.PRICING_CALCULATOR_MASTER_UPDATE_FAILURE,
  message,
  code,
})




